import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "17",
  height: "17",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#515151",
      d: "M8.5 0A8.497 8.497 0 0 0 0 8.5C0 13.197 3.803 17 8.5 17S17 13.197 17 8.5A8.5 8.5 0 0 0 8.5 0m4.782 11.856a1.008 1.008 0 0 1-1.426 1.426L8.5 9.926l-3.356 3.356a1.008 1.008 0 0 1-1.426-1.426L7.074 8.5 3.718 5.144a1.008 1.008 0 0 1 1.426-1.426L8.5 7.074l3.356-3.356a1.008 1.008 0 0 1 1.426 1.426L9.926 8.5z"
    }, null, -1)
  ]))]))
}
export default { render: render }